export default __webpack_public_path__ + "static/media/empty-content-table.9d931943.svg";